export default "__VITE_ASSET__C0qC13_g__"